import React, { Component } from 'react';
import AwardsComponent from './../components/awards';
import parseDate from './../utils/parseDate';

export default class InnerGetAward extends Component {
  constructor(props) {
    super (props)
    this.state = {
      isShow: false,
      awardsDom: null,
      curAwardInfo: {
        rateVal: '',
        nextornow: {},
        rewardInfo: {},
      }
    }
  }

  componentWillMount() {
    let info = JSON.parse(sessionStorage.getItem('yqs_curGame_awardInfo'))
    let awardInfo = Object.assign({}, {
      rateVal: info.globalfight,
      nextornow: info.nextornow,
      rewardInfo: info.reward
    })
    this.setState({awardsDom: <AwardsComponent rateVal={info.globalfight}/>, curAwardInfo: awardInfo})
  }

  _handleSeeAward() {
    let { rewardInfo } = this.state.curAwardInfo
    window.location.href = `${rewardInfo.rewardURL}`
  }

  _handleShare() {
    const {shareCallback} = this.props
    shareCallback({isShare: true})
  }

  _handleRemindMe() {
    const {remindCallback} = this.props
    remindCallback({isRemind: true})
  }

  render() {
    let { rewardInfo, nextornow } = this.state.curAwardInfo
    console.log('this.state_rewardInfo:::', rewardInfo)
    return (
      <div className='main_info'>
        {this.state.awardsDom}
        <div className='award_info'>
          <p className='tip'>本场获得奖励</p>
          <p className='award'>
            <span>{rewardInfo.rewardName}</span>
          </p>
        </div>
        {nextornow.nextTime !== 'noNext' ? <div className='nexttime'>下场预告 <span>{parseDate(nextornow.nextTime)}</span></div>: null}
        <div className='btn yellow' onClick={this._handleRemindMe.bind(this)} clstag="jr|keycount|yqsbhby|4">提醒我</div>
        <div className='btn blank' onClick={this._handleShare.bind(this)} clstag="jr|keycount|yqsbhby|5">炫耀一下</div>
      </div>
    )
  }
}